__turbopack_context__.v({
  "card": "CardTillamaps-module-scss-module__BWDjhW__card",
  "cardInner": "CardTillamaps-module-scss-module__BWDjhW__cardInner",
  "copy": "CardTillamaps-module-scss-module__BWDjhW__copy",
  "ctaWrapper": "CardTillamaps-module-scss-module__BWDjhW__ctaWrapper",
  "headline": "CardTillamaps-module-scss-module__BWDjhW__headline",
  "iconWrapper": "CardTillamaps-module-scss-module__BWDjhW__iconWrapper",
});
